module.exports = __webpack_public_path__ + "static/media/natasha.54a16ca1.jpeg";